<script lang="ts">
	import { SvgWrapper } from '../../../storybook-util/icons/components/SvgWrapper';
	import { getTailwindColor } from '../../../storybook-util/icons/utils/getTailwindColor/getTailwindColor';
	interface Props {
		color?: string | undefined;
		title?: string | undefined;
		class?: string;
	}

	let { color = 'gray-900', title = undefined, ...rest }: Props = $props();
</script>

<SvgWrapper {title} {...rest}>
	<path
		fill-rule="evenodd"
		clip-rule="evenodd"
		d="M17.8258 5.94844C16.2534 4.43259 14.1897 3.59961 12 3.59961C7.36784 3.59961 3.59998 7.36747 3.59998 11.9996C3.59998 16.6317 7.36784 20.3996 12 20.3996C16.6321 20.3996 20.4 16.6317 20.4 11.9996V11.6609C20.4 11.5112 20.2787 11.3899 20.129 11.3899H19.4516C19.3019 11.3899 19.1806 11.5112 19.1806 11.6609V11.9996C19.1806 15.9585 15.9589 19.1803 12 19.1803C8.04108 19.1803 4.81933 15.9585 4.81933 11.9996C4.81933 8.04071 8.04108 4.81896 12 4.81896C13.9181 4.81896 15.7206 5.5652 17.0753 6.91956L17.076 6.92021L17.1416 6.98671H14.7097C14.56 6.98671 14.4387 7.10802 14.4387 7.25767V7.93509C14.4387 8.08474 14.56 8.20606 14.7097 8.20606H18.4355C18.5073 8.20606 18.5762 8.17751 18.6271 8.1267L18.9658 7.78799C19.0166 7.73717 19.0451 7.66825 19.0451 7.59638V3.87058C19.0451 3.72093 18.9238 3.59961 18.7742 3.59961H18.0967C17.9471 3.59961 17.8258 3.72093 17.8258 3.87058V5.94844Z"
		fill={getTailwindColor(color)}
	/>
</SvgWrapper>
